import { Component, Input, OnInit } from '@angular/core';
import { I18nModule, Product, TranslationService, UrlModule, WindowRef } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { take } from 'rxjs';
import { AdvancedSearchService } from '../../advanced-search/core/advanced-search.service';
import { CollapseListModule } from '../../../../../../../components/collapse-list/collapse-list.module';
import { CollapseItem } from '../../../../../../../components/collapse-list/model/collapse.model';
import { QuotesService } from '../../../../core/quotes.service';
import { Option } from '../../../../../../../core/models/option.model';
import { ScreenViewModule } from '../../../../../../../core/directives/screen-view/_screen-view.module';
import { DEVICE_SIZE } from '../../../../../../../core/models/others.model';
import { ToasterService } from '../../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../../components/toaster/toaster.model';
import { ProductMediaComponent } from '../../../../../product/product-media/product-media.component';
import { slugify } from '../../../../../../../core/services/simple-tools';

@Component({
  selector: 'product-list-item',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    CollapseListModule,
    ScreenViewModule,
    ProductMediaComponent,
  ],
  templateUrl: './product-list-item.component.html',
  styleUrl: './product-list-item.component.scss',
})
export class ProductListItemComponent implements OnInit {
  @Input() product!: Product;

  DEVICE_SIZE = DEVICE_SIZE;
  keyFeatures: CollapseItem[] = [];
  slugify = slugify;

  speedRPMs$ = this.advancedSearchService.speedRPMs$;
  outputHPs$ = this.advancedSearchService.outputHPs$;
  voltages$ = this.advancedSearchService.voltages$;
  frameSizes$ = this.advancedSearchService.frameSizes$;
  outputKWs$ = this.advancedSearchService.outputKWs$;
  mountings$ = this.advancedSearchService.mountings$;
  phases$ = this.advancedSearchService.phases$;
  enclosures$ = this.advancedSearchService.enclosures$;

  constructor(
    private quotesFormService: QuotesService,
    private translationService: TranslationService,
    private winref: WindowRef,
    private advancedSearchService: AdvancedSearchService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.populateFeatures();
  }

  getLabel(code: string, listType: string): string {
    let list: Option[] = [];

    if (listType === 'speedRPMs' && this.speedRPMs$.getValue()?.length) {
      list = this.speedRPMs$.getValue();
    }

    if (listType === 'outputHPs' && this.outputHPs$.getValue()?.length) {
      list = this.outputHPs$.getValue();
    }

    if (listType === 'voltages' && this.voltages$.getValue()?.length) {
      list = this.voltages$.getValue();
    }

    if (listType === 'frameSizes' && this.frameSizes$.getValue()?.length) {
      list = this.frameSizes$.getValue();
    }

    if (listType === 'outputKWs' && this.outputKWs$.getValue()?.length) {
      list = this.outputKWs$.getValue();
    }

    if (listType === 'mountings' && this.mountings$.getValue()?.length) {
      list = this.mountings$.getValue();
    }

    if (listType === 'phases' && this.phases$.getValue()?.length) {
      list = this.phases$.getValue();
    }

    if (listType === 'enclosures' && this.enclosures$.getValue()?.length) {
      list = this.enclosures$.getValue();
    }

    if (this.advancedSearchService.isInList(code, list)) {
      return list.find(item => item.code === code)?.label || '';
    }

    return code;
  }

  addProduct(product: Product) {
    this.quotesFormService.addProduct(product);

    this.toasterService.closeALL();
    this.toasterService.init({
      type: TOASTER_TYPE.SUCCESS,
      content: `Product added to the list of products to be quoted.`,
    });
  }

  populateFeatures() {
    const $lis: HTMLLIElement[] = [];

    if (this.product.keySpecs?.length) {
      this.product.keySpecs?.forEach(spec => {
        const $li = this.winref.document.createElement(`li`);
        $li.innerText = spec;

        $lis.push($li);
      });
    } else {
      const $li = this.winref.document.createElement(`li`);

      this.translationService
        .translate('keyFeatures.noContent')
        .pipe(take(1))
        .subscribe(data => {
          $li.innerText = data;
        });

      $lis.push($li);
    }

    const $lisHtml = $lis.map(li => li.outerHTML).join('');

    this.keyFeatures = [
      {
        id: 'key-feature',
        title: 'Key Features',
        content: `
					<ul class="p-tb-0 m-0 p-rl-40">
						${$lisHtml}
					</ul>
				`,
        isOpen: false,
      },
    ];
  }
}
